import React, { FC } from 'react';

const VerticalLines: FC = () => {
  return (
    <div className="vertical-lines pr-2">
      <div className="item">
        <div className="sub-item">1</div>
        <div className="sub-item">2</div>
        <div className="sub-item">3</div>
        <div className="sub-item">4</div>
        <div className="sub-main">5</div>
      </div>
      <div className="item">
        <div className="sub-main">10</div>
      </div>
      <div className="item">
        <div className="sub-main">15</div>
      </div>
      <div className="item">
        <div className="sub-main">20</div>
      </div>
    </div>
  );
};

export default VerticalLines;
